import api from './api';

export interface CuentaCorrienteProveedorSaldo {
  nroProveedor: number;
  nombre: string;
  saldoTotal: number;
  saldoVencido: number;
  saldoVigente: number;
  ultimaActualizacion: string;
}

export interface CuentaCorrienteProveedorComprobante {
  compania: string;
  nroProveedor: string;
  nombre: string;
  fecha: string;
  comprobante: string;
  numero: string;
  importe: number;
  saldoDeb: number;
  saldoHab: number;
  fechaVenc: string;
  saldo: number;
  nroTipoFormulario: string;
  moneda: number;
  nroFormulario: number;
}

export interface EstadisticasCuentaCorrienteProveedores {
  totalProveedoresConCuentaCorriente: number;
  saldoTotalGeneral: number;
  saldoVencidoTotal: number;
  totalMovimientos: number;
  ultimaActualizacion: string;
}

export interface PaginatedResponse<T> {
  items: T[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

interface GetSaldosParams {
  pageNumber?: number;
  pageSize?: number;
  searchTerm?: string;
}

interface GetComprobantesParams {
  pageNumber?: number;
  pageSize?: number;
}

const parseResponse = <T>(data: unknown): T => {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data) as T;
    } catch (error) {
      console.error('No se pudo parsear la respuesta de Cuenta Corriente Proveedores:', error);
      throw new Error('Respuesta inválida del servidor de Cuenta Corriente Proveedores');
    }
  }

  return data as T;
};

const getSaldos = async ({
  pageNumber = 1,
  pageSize = 20,
  searchTerm
}: GetSaldosParams = {}): Promise<PaginatedResponse<CuentaCorrienteProveedorSaldo>> => {
  const params: any = {
    pageNumber,
    pageSize
  };
  
  if (searchTerm) {
    params.searchTerm = searchTerm;
  }
  
  const response = await api.get('/api/CuentaCorrienteProveedores/saldos', {
    params,
    headers: {
      Accept: 'text/plain'
    }
  });

  return parseResponse<PaginatedResponse<CuentaCorrienteProveedorSaldo>>(response.data);
};

const getComprobantesProveedor = async (
  nroProveedor: number,
  {
    pageNumber = 1,
    pageSize = 50
  }: GetComprobantesParams = {}
): Promise<PaginatedResponse<CuentaCorrienteProveedorComprobante>> => {
  const response = await api.get(`/api/CuentaCorrienteProveedores/proveedor/${nroProveedor}`, {
    params: {
      pageNumber,
      pageSize
    },
    headers: {
      Accept: 'text/plain'
    }
  });

  return parseResponse<PaginatedResponse<CuentaCorrienteProveedorComprobante>>(response.data);
};

const getEstadisticas = async (): Promise<EstadisticasCuentaCorrienteProveedores> => {
  const response = await api.get<EstadisticasCuentaCorrienteProveedores>('/api/CuentaCorrienteProveedores/estadisticas');
  return response.data;
};

const cuentaCorrienteProveedoresService = {
  getSaldos,
  getComprobantesProveedor,
  getEstadisticas
};

export default cuentaCorrienteProveedoresService;

